export default {
    ALL_ROLES_GET_REQUEST: "ALL_ROLES_GET_REQUEST",
    ALL_ROLES_GET_RECEIVE: "ALL_ROLES_GET_RECEIVE",
    ALL_ROLES_GET_ERROR: "ALL_ROLES_GET_ERROR"
};